/**
 * Реализация отображение списка пользователей
 * $TODO - на текущей итерации, заглушка (которая что-то там показывает)
 */

import React from 'react';
import {
    Datagrid,
    DateField,
    List,
    TextField,
    RaRecord,
    TextInput} from 'react-admin';
import DateRanges from 'components/date-range/ra-date-range';    


const getFilters = (permissions: string): React.ReactElement[] => {
  const retList: React.ReactElement[] = 
  [
    <TextInput source="user_name" label='User Name' autoFocus/>,
    <TextInput source="plan_name" label='Plan Name' autoFocus/>,
    <TextInput source="status" label='Status'/>,
    // <DateRanges source="created_at" label = 'Create At'/>,
    // <DateRanges source="modified_at" label = 'Modified At'/>
  ];
  return retList;
}

type RaProps = Omit<RaRecord, 'id'>;

interface Props extends RaProps {
  permission: string;
}

const InvoicesList: React.FC<Props> =  ({ permissions, ...props }) => {
  return <List
                title="Invoices"
                perPage={25}
                sort={{ field: 'modified_at', order: 'DESC' }}
                filters={getFilters(permissions)}
                bulkActionButtons={false}
                {...props}
                >
            <Datagrid 
                  bulkActionButtons={false}>
                <TextField source="user_name" label='User Name'/>
                <TextField source="plan_name" label='Plan Name'/>
                <TextField source="status" label='Status'/>
                <DateField source="created_at" label = 'Create At'/>
                <DateField source="modified_at" label = 'Modified At'/>
            </Datagrid>
          </List>
}

export default InvoicesList;
